import { useQuery } from "@tanstack/react-query";
import apiClient from "@/api/client";

interface ClientOption {
  id: string;
  name: string;
  short_name: string;
}

export function useClientsForTasks() {
  return useQuery({
    queryKey: ["clients-for-tasks"],
    queryFn: () =>
      apiClient
        .get<{ data: ClientOption[] }>("/clients/")
        .then((r) =>
          r.data.data
            .map((c) => ({ id: c.id, name: c.name, short_name: c.short_name }))
            .sort((a, b) => a.name.localeCompare(b.name, "pl")),
        ),
    staleTime: 10 * 60 * 1000,
  });
}
